import { carouselAnatomy } from "@ark-ui/react";
import { defineSlotRecipe } from "@pandacss/dev";

export const aromaCarousel = defineSlotRecipe({
  className: "aroma-carousel",
  slots: [...carouselAnatomy.keys(), "trigger", "controlWrapper"],
  jsx: ["Carousel"],
  base: {
    indicatorGroup: {
      display: "flex",
      gap: "gap.2",
    },
    indicator: {
      bg: "background.neutral-on-brand.base.subtle",
      w: "calc({spacing.padding.1} + {spacing.padding.0,5})",
      h: "calc({spacing.padding.1} + {spacing.padding.0,5})",
      borderRadius: "l",
      cursor: "pointer",
      "&[data-current]": {
        bg: "background.neutral-on-brand.base.bold",
        cursor: "default",
      },
      _focusVisible: {
        shadow: "effect.focus-ring.neutral",
        outline: "none",
      },
    },
    controlWrapper: {
      flexDirection: "column",
      alignItems: "center",
    },
    control: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      w: "100%",
      px: "padding.4",
    },
    trigger: {
      _disabled: {
        visibility: "hidden",
      },
    },
    item: {
      display: "flex",
      justifyContent: "center",
      pl: "padding.4",
      ml: "-padding.2",
      flex: "0 0 auto",
      width: "fit-content",
      "&:first-child": {
        paddingLeft: "padding.4",
      },
    },
    itemGroup: {
      width: "100% !important",
      gridAutoColumns: "auto !important",
      justifyItems: "center !important",
      paddingRight: "padding.4 !important",
      "& > *:first-child": {
        marginLeft: "0",
      },
    },
    root: {
      w: "100%",
      spaceY: "gap.2",
    },
  },
});
